// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

export const noop = () => undefined;
